<div class="container-welcome" fxLayout="row">
  <div class="left"></div>
  <div class="middle">
    <h1>Contactformulier proeflicentie</h1>
      <p>
        Uw aanvraag is succesvol verzonden. Wij zullen zo spoedig mogelijk contact met u opnemen.
      </p>
      </div>
      <div class="right"></div>
    </div>